<template>
   <div>
<!--     &lt;!&ndash; Background Pattern &ndash;&gt;-->
<!--     <img-->
<!--      src="../assets/images/desktop1-image.png"-->
<!--      alt="Background pattern"-->
<!--      class="hidden lg:block background-pattern overflow-hidden"-->
<!--    />-->
<!--    <img-->
<!--      src="../assets/images/mobile-image.png"-->
<!--      alt="Background pattern"-->
<!--      class="block lg:hidden background-pattern overflow-hidden"-->
<!--    />-->
  <section class="hero-section px-5 lg:px-32">

    <div class="hero-content">
      <h1 class="hero-title">
        <span class="text-line">Meet Catalyst.</span>
        <span class="text-line">The <span class="gradient-text">plug+play creative </span></span>
        <div class="text-line">
          <span class="gradient-text">engine</span><span class="text-white"> for scaling brands. </span>
        </div>
      </h1>
      <p class="hero-subtitle xl:whitespace-nowrap">
        The science behind scaling brands profitably - through creative, data, and performance
      </p>
    </div>
  </section>
   </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { gsap } from 'gsap';
import { TextPlugin } from 'gsap/TextPlugin';

gsap.registerPlugin(TextPlugin);

onMounted(() => {
  const tl = gsap.timeline({
    defaults: { ease: "power3.out" }
  });

  // Animate text lines
  tl.from(".text-line", {
    y: 100,
    opacity: 0,
    duration: 1,
    stagger: 0.3,
  });

  // Animate subtitle
  tl.from(".hero-subtitle", {
    y: 30,
    opacity: 0,
    duration: 1,
  }, "-=0.5");

  // Gradient shine effect
  gsap.to(".gradient-text", {
    backgroundPosition: "300% center",
    duration: 4,
    repeat: -1,
    ease: "none"
  });
});
</script>

<style scoped>
.hero-section {
  min-height: calc(100vh - 73px);
  display: flex;
  align-items: end;
  justify-content: flex-start;
/*  background-image: url("../assets/images/desktop1-image.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;*/
  /* padding: 2rem; */
  background-color: #161816;
  position: relative;
  overflow: hidden;
  font-family: 'Helvetica Now Display', sans-serif;
}

.hero-content {
  max-width: 1200px;
  /* margin: 0 auto; */
  /* padding: 0 1rem; */
  position: relative;
  z-index: 2;
}

.background-pattern {
  position: absolute;
  top: 5rem;
  right: 0;
  height: 632px;
  width: 632px;
  object-fit: cover;
  z-index: 1;
  opacity: 0.8;
}

.hero-title {
  padding: 5px 0;
  font-size: clamp(2.5rem, 5vw, 4.5rem);
  line-height: 1.2;
  color: #ffffff;
  margin-bottom: 1.5rem;
  font-weight: 500;
  font-family: 'Helvetica Now Display', sans-serif;
}

.text-line {
  display: block;
  overflow: hidden;
}

.gradient-text {
  background: linear-gradient(
      90deg,
      #52e475 0%,
      #3cdff8 25%,
      #e248ce 50%,
      #3cdff8 75%,
      #52e475 100%
  );
  background-size: 300% auto;
  background-position: 0% center;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}

.hero-subtitle {
  font-size: clamp(12px, 2vw, 24px);
  color: white;
  max-width: 600px;
  line-height: 1.6;
  font-family: 'Helvetica Now Display', sans-serif;
  font-weight: 500;
}

/* Mobile styles */
@media (max-width: 768px) {
  .hero-section {
    padding: 1rem;
    text-align: left;
/*    background-image: url("../assets/images/img.png");
    background-size: 200px;
    background-position-x: right;
    background-position-y: top;*/
  }

  .hero-content {
    padding: 0;
  }

  .hero-title {
    font-size: 30px;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .background-pattern {
    top: 3rem;
    right: 0;
    height: 300px;
    width: 300px;
    opacity: 0.8;
  }
}
</style>
